export { ConfirmModal } from './ConfirmModal'


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/ConfirmModal/index.js